

// src/app/(main)/rfq/rfq.js

'use client'

import AliUpload from "@/components/AliUpload/upload";
import { Form, Input, Select, Button, Space, message, Spin, Divider, Row, Col } from "antd"

import Image from "next/image"
import _ from 'lodash';
import { createClientService } from "@/lib/http/client";
import { useEffect, useState } from "react";
import { useSearchParams } from 'next/navigation';
import { isNull } from "@/lib/utils";
import { useApi } from '@/context/hooks/useApi';
import { countryCodes } from '@/lib/countryCodes'
import { useRouter } from 'nextjs-toploader/app';


const dateList = [
    {
        value: 0,
        label: "spot",
    },
    {
        value: 7,
        label: "Within 7 days",
    },
    {
        value: 15,
        label: "Within 15 days",
    },
    {
        value: 30,
        label: "Within 30 days",
    },
    {
        value: 60,
        label: "Within 2 months",
    },
]


export default function Rfq(props) {


    const [unit, setUnit] = useState([])

    const api = useApi();


    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);

    const countryRegionOptions = countryCodes;

    const searchParams = useSearchParams();

    const router = useRouter();

    const formatFile = (url) => url ? [{
        uid: '-1',                 // 唯一标识
        name: 'existing-file',     // 显示文件名
        status: 'done',            // 上传状态
        url: url                   // 图片地址
    }] : [];



    useEffect(() => {
        setLoading(true)

        const pn = searchParams.get('pn');
        const q = searchParams.get('q');
        const unitId = searchParams.get('unitId') || 'config_40';

        const id = searchParams.get('id');

        try {
            let units = []
            if (typeof window !== 'undefined') {
                units = JSON.parse(localStorage.getItem('unit'));
                if (isNull(units)) {
                    // 010801_获取用户单位列表
                    api.authGet('mtop.user.getUserUnitList', {}, { v: '3.0' }).then(res => {
                        localStorage.setItem('unit', JSON.stringify(res.configList));
                        setUnit(res.configList)
                    })
                } else {
                    setUnit(units)
                }
            }

            if (!isNull(id)) {
                api.authGet('mtop.order.business.sdb', { data: { id } }).then(res => {

                    const { pn, ds, wd, no, unitId, countryCode, mobile, email, invitationCode, ps } = res;

                    let data = {
                        pn: pn,
                        desc: ds,
                        wd,
                        sourcing: { q: no, unitId },
                        phone: { countryCode, mobile },
                        email,
                        invitationCode,
                    };

                    let pics = []; ps.map((item, key) => {
                        pics.push({
                            url: item.p.split('?')[0],
                            uid: `uid_${key + 1}`,
                            status: 'done',
                            name: `existing-file${key}.png`,
                            dimension: { width: item.w || 0, height: item.h || 0 }
                        })
                    })

                    data.pics = pics;
                    data.fileList = pics;


                    form.setFieldsValue({ ...data })
                })

                return
            }


            api.authGet('mtop.order.business.bnew').then(res => {
                const { email, countryCode, mobile, invitationCode } = res
                form.setFieldsValue({ phone: { countryCode: countryCode, mobile }, email, invitationCode })
            }).catch(err => {
                console.log("🚀 ~ createClientService ~ err:", err)
            }).finally(() => {
                setLoading(false)
            })


            form.setFieldsValue({ pn, sourcing: { q, unitId } })
        } catch (error) {
            console.log("🚀 ~ useEffect rfq ~ error:", error)
        } finally {
            setLoading(false)
        }



    }, [])


    const normFile = e => {
        if (Array.isArray(e)) {
            return e;
        }
        return e === null || e === void 0 ? void 0 : e.fileList;
    };


    const onFinish = _.debounce((values) => {

        setLoading(true);

        let picsArr = values?.pics || [];

        if (picsArr.length > 0) {
            picsArr = picsArr.map((item) => {
                return { p: item.url.split('?')[0], w: item?.dimension?.width || 100, h: item?.dimension?.height || 100 };
            });
        }

        let data = {
            ...values,
            q: values?.sourcing?.q,
            unitId: values?.sourcing?.unitId,
            pics: JSON.stringify(picsArr),
            countryCode: values.phone.countryCode,
            mobile: values.phone.mobile,
            phone: '',
            sourcing: '',
            sc: "2034",
            from: "10",
            ste: "4",
        }

        // 201002_发布求购信息
        api.authPost('mtop.order.business.newSubject', { ...data }).then(res => {
            message.success('Submission successful');
            form.resetFields();
            router.push('/success?type=rfq');
        }).catch(err => {
            console.error("🚀 ~ onFinish ~ err:", err)
            message.error(err?.msg || 'Submission failed');
        }).finally(() => {
            setLoading(false);
        });

    }, 300);



    return <Spin spinning={loading}>
        <Form
            form={form}
            size="large"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 16 }}
            onFinish={onFinish}
            colon={false}
        >

            <Form.Item
                className="pd-r-20"
                label="Product Name："
                name="pn"
                rules={[{ required: true, message: 'Please enter the product name' }]}
            >
                <Input placeholder="Please enter the product name" maxLength={100} />
            </Form.Item>

            <Form.Item
                className="pd-r-20"
                label="Detailed Requirements："
                name="desc"
                rules={[{ required: true, message: 'Please enter detailed requirements' }]}
            >
                <Input.TextArea showCount maxLength={500} autoSize={{ minRows: 6 }} placeholder="Describe product details, such as export country, price, material, specifications, etc." />
            </Form.Item>


            <Form.Item className="pd-r-20" name="pics" label=" " getValueFromEvent={normFile}>
                <AliUpload picDir="1/buy/" max={9} />
            </Form.Item>



            <Form.Item
                className="pd-r-20"
                label="Delivery Date："
                name="wd"
                rules={[{ required: true, message: 'Please select Delivery Date' }]}>
                <Select placeholder="Please select Delivery Date">
                    {
                        dateList.map((item, index) => <Select.Option key={index} value={item.value}>{item.label}</Select.Option>)
                    }
                </Select>
            </Form.Item>

            <Form.Item label="Sourcing Quantity：" required className="pd-r-20">
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name={['sourcing', 'q']}
                            noStyle
                            rules={[{ required: true, message: 'the quantity is required' }]}
                            width={20}
                        >
                            <Input placeholder="Please enter the quantity" maxLength={8} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name={['sourcing', 'unitId']}
                            noStyle
                            rules={[{ required: true, message: 'Uint is required' }]}
                        >
                            <Select
                                placeholder="Please enter the Uint"
                                showSearch
                                options={unit}
                                fieldNames={{ value: 'id', label: 'nameEn' }}
                                optionFilterProp="nameEn"
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form.Item>

            <Divider />

            <Form.Item
                className="pd-r-20"
                label="Email："
                name="email"
                rules={[
                    { required: true, message: 'Please enter your Email' },
                    {
                        type: 'email',
                        message: 'Please enter the correct email format',
                    },
                ]}
            >
                <Input placeholder="Please enter your Email" maxLength={100} />
            </Form.Item>

            <Form.Item label="Mobile Number：" required className="pd-r-20">
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            name={['phone', 'countryCode']}
                            noStyle
                            rules={[{ required: true, message: 'countryCode is required' }]}
                            width={20}
                        >
                            <Select
                                placeholder="Please select countryCode"
                                showSearch
                                options={countryRegionOptions}
                                fieldNames={{ value: 'code', label: 'code' }}
                                // 关键修改：自定义搜索逻辑
                                filterOption={(input, option) => {
                                    // 同时匹配 name 和 code
                                    const name = String(option?.name || '').toLowerCase();
                                    const code = String(option?.code || '').toLowerCase();
                                    const query = input.toLowerCase();
                                    return name.includes(query) || code.includes(query);
                                }}
                                optionRender={(option) => (
                                    <Space>
                                        <Image src={option.data.flag} width={40} height={20} alt={option.data.name} />
                                        {option.data.name}
                                        <span>{option.data.code}</span>
                                    </Space>
                                )} />
                        </Form.Item>
                    </Col>
                    <Col span={16}>
                        <Form.Item
                            name={['phone', 'mobile']}
                            noStyle
                            rules={[{ required: true, message: 'Please enter your mobile number' }]}
                        >
                            <Input placeholder="Please enter your mobile number" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form.Item>


            <Form.Item className="pd-r-20" name="invitationCode" label="Invitation Code：">
                <Input placeholder="Please enter your invitation Code (Optional)" maxLength={20} />
            </Form.Item>




            <Form.Item label={null}>
                <Button htmlType="submit" className="submit-btn" color="danger" variant="solid">
                    Submit
                </Button>
            </Form.Item>

        </Form>
    </Spin>
}